// extracted by mini-css-extract-plugin
export default {"popularSportsSlider":"PopularSports_popularSportsSlider--zLS","gridItem":"PopularSports_gridItem--A13"};